import React, { useState } from "react";
import { Form, Input, Button, Card, Typography, App, Alert } from "antd";
import { useLogin } from "@refinedev/core";
import {
  UserOutlined,
  LockOutlined,
  PlayCircleOutlined,
} from "@ant-design/icons";
import "./LoginPage.css";

const { Title, Text } = Typography;

export const LoginPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const { mutate: login } = useLogin();

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);

    try {
      await login(values, {
        onSuccess: () => {
          // Le message de succès sera géré par Refine automatiquement
        },
        onError: () => {
          // L'erreur sera gérée par Refine automatiquement
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <App>
      <div className="login-container">
        <div className="login-background">
          <div className="login-content">
            <Card className="login-card">
              <div className="login-header">
                <div className="login-logo">
                  <PlayCircleOutlined
                    style={{ fontSize: 48, color: "#1890ff" }}
                  />
                </div>
                <Title level={2} className="login-title">
                  Filmika Dashboard
                </Title>
                <Text type="secondary" className="login-subtitle">
                  Connexion à l'administration Filmika
                </Text>
              </div>

              <Form
                name="login"
                onFinish={onFinish}
                autoComplete="off"
                size="large"
                className="login-form"
              >
                <Form.Item
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez saisir votre nom d'utilisateur",
                    },
                  ]}
                >
                  <Input
                    prefix={<UserOutlined />}
                    placeholder="Nom d'utilisateur"
                    className="login-input"
                  />
                </Form.Item>

                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez saisir votre mot de passe",
                    },
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined />}
                    placeholder="Mot de passe"
                    className="login-input"
                  />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    className="login-button"
                    block
                  >
                    Se connecter
                  </Button>
                </Form.Item>
              </Form>

              <div className="login-footer">
                <Alert
                  message="Informations de connexion"
                  description="Utilisez vos identifiants administrateur pour accéder au dashboard."
                  type="info"
                  showIcon
                  className="login-alert"
                />
              </div>
            </Card>
          </div>
        </div>
      </div>
    </App>
  );
};
